import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';


const server_backend = config.API_URL;

function CreateOptionJobValue({ username, onClose }) {
    const [loading, setLoading] = useState(false);
    const [JobCategory, setJobCategory] = useState([]);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        optjc_id: "",
        value: "",
        comment: ""

    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        const getJobCategory = async () => {
            try {
                const response = await axios.get(`${server_backend}/options_job_category/list`, headers);

                if (response.data.RES_CODE === "00") {
                    setJobCategory(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getJobCategory();
    }, []);


    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log(formData)
        try {
            const response = await axios.post(`${server_backend}/options_job_value/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/option-job-value');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Option Job Value already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Option Job Value</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/option-job-value" onClick={onClose}>Go Back</Link>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-6">
                                        <div className="mb-3">
                                            <label htmlFor="optjc_id" className="form-label">Option Category</label>
                                            <select
                                                className="form-select"
                                                aria-label=".form-select-sm example"
                                                name="optjc_id"
                                                value={formData.optjc_id}
                                                onChange={handleChange}
                                            ><option>Select the option</option>
                                                {JobCategory.map((OptionJ) => (
                                                    <option key={OptionJ.optjc_ID} value={OptionJ.optjc_ID}>
                                                        {OptionJ.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <br />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="value" className="form-label">Value</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="value"
                                            value={formData.value}
                                            onChange={handleChange}
                                            
                                        />
                                    </div>
                                  
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default CreateOptionJobValue;
